export const CAREGIVER_PENDING_APPROVAL_ERROR_MESSAGE =
  "You don't have access to use Wellframe yet. The care team must approve your account to continue.";

// Login Access Restriction Error Code from backend (non-standard response format)
export enum ErrorCodes {
  APPLICATION_FORBIDDEN = 'APPLICATION_FORBIDDEN',
}
